// extracted by mini-css-extract-plugin
export var avatarContainer = "_98-0";
export var avatarTypingWave = "_98-i";
export var gray = "_98-f";
export var green = "_98-c";
export var icon = "_98-9";
export var image = "_98-1";
export var lg = "_98-6";
export var md = "_98-5";
export var presenceDot = "_98-b";
export var red = "_98-d";
export var sm = "_98-4";
export var status = "_98-a";
export var typingDot = "_98-h";
export var typingPill = "_98-g";
export var xl = "_98-7";
export var xs = "_98-3";
export var xxl = "_98-8";
export var xxs = "_98-2";
export var yellow = "_98-e";